export const GET_LETTER_TEMPLATE_ERROR_MSG = 'GET_LETTER_TEMPLATE_ERROR_MSG';
export const GET_LETTER_TEMPLATE_FILTER_DATA =
  'GET_LETTER_TEMPLATE_FILTER_DATA';
export const GET_LETTER_TEMPLATE_DETAIL_API = 'GET_LETTER_TEMPLATE_DETAIL_API';
export const GET_TEMPLATE_TYPE_LIST = 'GET_TEMPLATE_TYPE_LIST';
export const GET_COPY_LETTER_TEMPLATE_LIST = 'GET_COPY_LETTER_TEMPLATE_LIST';
export const GET_LETTER_TEMPLATE_LIST = 'GET_LETTER_TEMPLATE_LIST';
export const GET_LETTER_TEMPLATE_EXTRA_STATE_FROM_OTHER =
  'GET_LETTER_TEMPLATE_EXTRA_STATE_FROM_OTHER';
export const GET_LETTER_TEMPLATE_DETAIL_LIST =
  'GET_LETTER_TEMPLATE_DETAIL_LIST';
export const FETCH_LETTER_TEMPLATE_DETAIL_LIST =
  'FETCH_LETTER_TEMPLATE_DETAIL_LIST';
export const GET_LETTER_TEMPLATE_EXTRA_STATE =
  'GET_LETTER_TEMPLATE_EXTRA_STATE';
export const GET_PREVOIUS_TEMPLATE_VERSION_LIST_STATE =
  'GET_PREVOIUS_TEMPLATE_VERSION_LIST_STATE';
export const GET_ALL_MERGE_FIELD_LIST_STATE = 'GET_ALL_MERGE_FIELD_LIST_STATE';
export const GET_ALL_SUB_MERGE_FIELD_LIST_STATE =
  'GET_ALL_SUB_MERGE_FIELD_LIST_STATE';
export const GET_LETTER_TEMPLATE_DETAIL_TAB_STATE =
  'GET_LETTER_TEMPLATE_DETAIL_TAB_STATE';
export const GET_LETTER_TEMPLATE_DETAIL_SAVE =
  'GET_LETTER_TEMPLATE_DETAIL_SAVE';
export const GET_ALL_SELECTED_MERGE_FIELD = 'GET_ALL_SELECTED_MERGE_FIELD';
export const GET_MANUFACTURER_LIST = 'GET_MANUFACTURER_LIST';
export const GET_PREVIEW_TEMPLATE = 'GET_PREVIEW_TEMPLATE';
export const GET_COVER_MERGE_FIELD_LIST_STATE =
  'GET_COVER_MERGE_FIELD_LIST_STATE';
export const GET_COLLECT_MERGE_FIELD_LIST_STATE =
  'GET_COLLECT_MERGE_FIELD_LIST_STATE';
export const GET_DISPUTE_MERGE_FIELD_LIST_STATE =
  'GET_DISPUTE_MERGE_FIELD_LIST_STATE';
export const GET_WINDOW_ADDRESS_POSITION_LIST =
  'GET_WINDOW_ADDRESS_POSITION_LIST';
export const GET_TEMPLATE_LIST_FOR_VALIDATION_CHECK =
  'GET_TEMPLATE_LIST_FOR_VALIDATION_CHECK';
export const GET_LETTER_TEMPLATE_DETAIL_COPY_LIST =
  'GET_LETTER_TEMPLATE_DETAIL_COPY_LIST';
export const GET_PDF_PRINT_PREVIEW = 'GET_PDF_PRINT_PREVIEW';
export const GET_GENERAL_SYSTEM_PARAMETER = 'GET_GENERAL_SYSTEM_PARAMETER';
export const GET_ALL_MERGE_FIELD_LIST_FOR_DEFAULT_FOOTER_STATE =
  'GET_ALL_MERGE_FIELD_LIST_FOR_DEFAULT_FOOTER_STATE';
export const AUTO_SEND_INDICATOR_VALIDATION = 'AUTO_SEND_INDICATOR_VALIDATION';
export const DRAMS_INVOICE_START_QTR = 'DRAMS_INVOICE_START_QTR';
export const LETTER_TEMPLATE_CLEAR_REDUX_DATA =
  'LETTER_TEMPLATE_CLEAR_REDUX_DATA';
export const GET_REMOVE_LETTER_TEMPLATE_ERROR_MSG =
  'GET_REMOVE_LETTER_TEMPLATE_ERROR_MSG';
export const GET_REMOVE_LETTER_TEMPLATE_EXTRA_STATE =
  'GET_REMOVE_LETTER_TEMPLATE_EXTRA_STATE';
export const GET_SENT_LETTER =
  'GET_SENT_LETTER';
